<ng-container *ngIf="designVersion !== 'v3'">
<div class="sub-entities-scroll-container" *ngIf="loadAPIcall && viewedList?.length==0">
  <app-common-skeleton [countforView]="10" [NameOftheScreen]="'likeviewcard'"></app-common-skeleton>
</div>

<div class="sub-entities-scroll-container" *ngIf="viewedList.length > 0; else noResult" infiniteScroll
  [infiniteScrollDistance]="2" [infiniteScrollThrottle]="200" [scrollWindow]="false" [alwaysCallback]="true"
  (scrolled)="onScrollDown()">
  <div class="hpanel" *ngFor="let items of viewedList">
    <div class="panel-body border-radius-top-left-right-6" [ngClass]="{'disabled':jobDetails?.status !='ACTIVE'}">
      <div class="row">
        <div class="col-sm-8">
          <div class="view-card">
            <img id="job_viewed_user_profile_image" *ngIf="items.logo" class="img-circle m-r-4" src="{{items.logo}}" (click)="profile(items.userId)">
            <div *ngIf="!items.logo">
              <div class="circles" [style.background-color]="getColortwo(items?.firstName, items?.lastName)">
                <div class="circle-text" [style.color]="getTextColor(items?.firstName, items?.lastName)">{{
                  getInitialstwo(items?.firstName, items?.lastName) }}</div>
              </div>
            </div>
            <div class="details-grid">
              <div class="view-name">
                <h6 class="fw-bold m-0">
                  {{items.firstName}} {{items.lastName}}
                </h6>
              </div>
              <div class="view-title">
                <span *ngIf="items.UserType === 'FREELANCE_RECRUITER'">Freelance Recruiter</span>
                <span *ngIf="items.UserType === 'RECRUITER'">Recruiter</span>
                <span *ngIf="items.UserType === 'JOB_SEEKER'">Job Seeker</span>
                <span *ngIf="items.UserType === 'MANAGEMENT_TALENT_ACQUISITION'">MTA</span>
                <span *ngIf="items.UserType === 'BENCH_RECRUITER'">Bench Recruiter</span>
                <span *ngIf="items.organisation"> &#64; {{items.organisation}}</span>
              </div>
              <div class="view-time">
                <!-- <ng-icon name="tablerEye"></ng-icon> -->
                <span>Viewed at {{items.activityDate | timezoneDate}}</span>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="LoginUserId!=items.userId" class="col-sm-4 chaticon">
          <div id="job_viewed_chat_button" class="chat-button" title="{{items?.nonSeenMessageCount}} Messages"
            (click)="chatuser(items, connectionTemplate)">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
            <span class="blue-color">{{items?.nonSeenMessageCount}}</span>
            <span>Chat</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
</ng-container>

<ng-container *ngIf="designVersion === 'v3'">
  <!-- Infinite scroll delegated to the outer `.jc-v3-entity-details-body`
       container. Do NOT add `.sub-entities-scroll-container` here — that
       V2-only class globally sets `overflow-y: scroll` (_common.scss:2305)
       and makes this div its own scroll viewport, stealing wheel events
       from the outer container so `(scrolled)` never fires. -->
  <!-- Job-level disable: blocked / non-active job greys the V3 Views
       listing and blocks pointer events. Matches V2 wrapper above.
       Bound per-row below (not on this wrapper) so it no longer also dims
       the "No Views Yet" empty state, which has nothing to grey out or
       block clicks on. -->
    <div infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="200"
    [infiniteScrollContainer]="'.jc-v3-entity-details-body'"
    [fromRoot]="true"
    [alwaysCallback]="true"
    (scrolled)="onScrollDown()">
    <app-common-skeleton *ngIf="loadAPIcall && viewedList?.length === 0" [countforView]="5"
      [NameOftheScreen]="'likeviewcard'"></app-common-skeleton>
    <!-- Click on avatar / name / info area routes to the viewer's public
         profile. Mirrors baseline V2 pattern
         (jobs-viewed-by.component.html:12, baseline) which wired
         `(click)="profile(items.userId)"` on the image. -->
    <div class="jc-v3-person-item" *ngFor="let items of viewedList"
      [ngClass]="{'disabled': jobDetails?.status !== 'ACTIVE'}">
      <img *ngIf="items?.logo" class="jc-v3-p-av jc-v3-p-clickable"
        [src]="items.logo" alt="avatar"
        (click)="profile(items.userId)"
        (error)="$any($event.target).style.display='none'">
      <div *ngIf="!items?.logo" class="jc-v3-p-av jc-v3-p-clickable"
        [style.background-color]="getColortwo(items?.firstName, items?.lastName)"
        [style.color]="getTextColor(items?.firstName, items?.lastName)"
        (click)="profile(items.userId)">
        {{ getInitialstwo(items?.firstName, items?.lastName) }}
      </div>
      <div class="jc-v3-p-info jc-v3-p-clickable" (click)="profile(items.userId)">
        <div class="jc-v3-p-name">{{ items?.firstName }} {{ items?.lastName }}</div>
        <div class="jc-v3-p-role">
          <span *ngIf="items.UserType === 'FREELANCE_RECRUITER'">Freelance Recruiter</span>
          <span *ngIf="items.UserType === 'RECRUITER'">Recruiter</span>
          <span *ngIf="items.UserType === 'JOB_SEEKER'">Job Seeker</span>
          <span *ngIf="items.UserType === 'MANAGEMENT_TALENT_ACQUISITION'">MTA</span>
          <span *ngIf="items.UserType === 'BENCH_RECRUITER'">Bench Recruiter</span>
          <span *ngIf="items?.organisation"> &middot; {{ items.organisation }}</span>
        </div>
      </div>
      <div class="jc-v3-p-time">{{ items?.activityDate | timezoneDate }}</div>
      <button type="button" class="jc-v3-p-chat"
        *ngIf="LoginUserId != items.userId"
        
        (click)="chatuser(items, connectionTemplate); $event.stopPropagation()">
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
        <span class="jc-v3-p-chat-count" *ngIf="items?.nonSeenMessageCount > 0">{{ items.nonSeenMessageCount }}</span>
        <span>Chat</span>
      </button>
    </div>
    <app-common-skeleton *ngIf="loadAPIcall && viewedList?.length > 0" [countforView]="5"
      [NameOftheScreen]="'likeviewcard'"></app-common-skeleton>
    <div *ngIf="stopscrollFlag && viewedList?.length > 0" class="jc-v3-list-done">
      <ng-icon name="tablerCircleCheck"></ng-icon>
      <p>You've reached the bottom of the page</p>
    </div>
    <div *ngIf="!loadAPIcall && viewedList?.length === 0" class="jc-v3-empty-state">
      <svg width="200" height="180" viewBox="0 0 200 180" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="100" cy="90" r="80" fill="#F5F3FF"/>
        <ellipse cx="100" cy="90" rx="46" ry="28" fill="#EDE9FE" stroke="#7C3AED" stroke-width="1.8"/>
        <circle cx="100" cy="90" r="14" fill="#ffffff" stroke="#7C3AED" stroke-width="2"/>
        <circle cx="100" cy="90" r="7" fill="#DDD6FE"/>
        <circle cx="100" cy="90" r="3" fill="#7C3AED"/>
        <line x1="60" y1="78" x2="54" y2="72" stroke="#C4B5FD" stroke-width="1.5" stroke-linecap="round"/>
        <line x1="140" y1="78" x2="146" y2="72" stroke="#C4B5FD" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="148" cy="128" r="16" fill="#7C3AED" opacity="0.10"/>
        <circle cx="148" cy="128" r="11" fill="#ffffff" stroke="#7C3AED" stroke-width="2"/>
        <path d="M143 128 a5 5 0 0 1 10 0 a5 5 0 0 1 -10 0" fill="none" stroke="#7C3AED" stroke-width="1.8"/>
        <circle cx="148" cy="128" r="2.5" fill="#7C3AED"/>
        <circle cx="50" cy="52" r="3" fill="#A78BFA"/>
        <circle cx="155" cy="56" r="2" fill="#C4B5FD"/>
      </svg>
      <h3>No Views Yet</h3>
      <p>Candidates who view this job will appear here.</p>
    </div>
       <div #scrollSentinel style="height:1px;"></div>
  </div>
</ng-container>


<!-- <div class="view-list-container" *ngIf="viewedList.length > 0; else noResult" infiniteScroll
    [infiniteScrollDistance]="2" [infiniteScrollThrottle]="1500" [scrollWindow]="false" (scrolled)="onScrollDown()">
    <div class="view-list-header">
      <h3>Recent Viewers</h3>
      <span class="view-count">24 views</span>
    </div>

    <ul class="viewers-list" *ngFor="let items of viewedList">
      <li class="viewer-item">
        <img *ngIf="items.logo" class="img-circle m-r-4" src="{{items.logo}}" (click)="profile(items.userId)">
        <div *ngIf="!items.logo">
          <div class="circles" [style.background-color]="getColortwo(items?.firstName, items?.lastName)">
            <div class="circle-text" [style.color]="getTextColor(items?.firstName, items?.lastName)">{{
              getInitialstwo(items?.firstName, items?.lastName) }}</div>
          </div>
        </div>

        <div class="viewer-info">
          <h4 class="viewer-name"> {{items.firstName}} {{items.lastName}}</h4>
          <p class="viewer-title">
            <span *ngIf="items.UserType === 'FREELANCE_RECRUITER'">Freelance Recruiter</span>
            <span *ngIf="items.UserType === 'RECRUITER'">Recruiter</span>
            <span *ngIf="items.UserType === 'JOB_SEEKER'">Job Seeker</span>
            <span *ngIf="items.UserType === 'MANAGEMENT_TALENT_ACQUISITION'">MTA</span>
            <span *ngIf="items.UserType === 'BENCH_RECRUITER'">Bench Recruiter</span>
            <span *ngIf="items.organisation"> &#64; {{items.organisation}}</span>
          </p>
          <span class="view-time">
            Viewed  <span>{{items.activityDate | timezoneDate}}</span>
          </span>
        </div>

        <button class="chat-button"  *ngIf="LoginUserId!=items.userId" 
        title="{{items?.nonSeenMessageCount}} Messages" (click)="chatuser(items, connectionTemplate)">
          <i class="message-icon"></i>
          Chat
        </button>
      </li>
    </ul>
  </div> -->

<!-- Legacy V2-only trailing markup: these orphan blocks used to render
     regardless of design version, which duplicated the end-of-list card
     on V3 (V3 already renders `.jc-v3-list-done` inside its own gated
     block above). Gated here so they only render on V2. -->
<ng-container *ngIf="designVersion !== 'v3'">
  <app-common-skeleton *ngIf="loadAPIcall && viewedList?.length>0" [countforView]="5"
    [NameOftheScreen]="'likeviewcard'"></app-common-skeleton>

  <div class="gs-end-of-list" *ngIf="stopscrollFlag && viewedList?.length > 0">
    <div class="wert">
      <div class="col-md-12 mg-bt-9">
               <ng-icon name="tablerCircleCheck"></ng-icon>
      </div>
      <div class="col-md-12">
        <p class="font-16">You've reached the bottom of the page</p>
      </div>
    </div>
  </div>
</ng-container>


<ng-template #noResult>
  <div class="wert">
    <div class="col-md-12 mg-bt-9">
    <ng-icon name="tablerZoomQuestion"></ng-icon>
    </div>
    <div class="col-md-12 fig">No views yet.</div>
  </div>
</ng-template>


<ng-template #connectionTemplate>
  <app-connection-template [page]="'job-card-1'" [connectionStatus]="connectionStatus"
    [counterpartsDetails]="counterpartsDetails" [values]="values"></app-connection-template>
</ng-template>
<app-message-widget *ngIf="messagemodelflag" (closeMessageModel)="closeMessage($event)" [messageDataPass]="messageData">
</app-message-widget>